import type { RecipeVariants } from "@vanilla-extract/recipes";
import type { ReactNode } from "react";
import { signedNumber } from "../fmt.ts";
import { cap } from "./style.css.ts";

export function Cap(
  props: {
    cost: ReactNode;
    label: string;
    additionalInfo?: ReactNode;
    size?: string;
    diff?: number;
  } & RecipeVariants<typeof cap.container>,
) {
  const { cost, label, additionalInfo, size, tilt, diff } = props;
  return (
    <div className={cap.container({ tilt })} style={{ fontSize: size }}>
      {!!diff && (
        <div className={cap.diff({ isNegative: diff < 0 })}>
          {signedNumber(diff)}
        </div>
      )}

      <div className={cap.value}>{cost}</div>

      <div className={cap.label({ small: label.length > 5 })}>{label}</div>

      {additionalInfo && <div className={cap.info}>{additionalInfo}</div>}
    </div>
  );
}

export function Bottle(
  props: {
    cost: ReactNode;
    label: string;
    size?: string;
    diff?: number;
  } & RecipeVariants<typeof cap.container>,
) {
  const { cost, label, size, tilt, diff } = props;
  return (
    <div
      className={cap.container({ tilt, image: "bottle" })}
      style={{ fontSize: size }}
    >
      {!!diff && (
        <div className={cap.diff({ isNegative: diff < 0 })}>
          {signedNumber(diff)}
        </div>
      )}

      <div className={cap.value}>{cost}</div>

      <div className={cap.label({ small: label.length > 5 })}>{label}</div>
    </div>
  );
}
